import IqosQuizGame from './IqosQuizGame';

export default IqosQuizGame;
